import React, { useContext } from "react";
import { Box } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";
import SubMenu from "../components/SubMenu";
import AddGuestHouse from "../components/AddGuestHouse";
import ManageGuestHouse from "../components/ManageGuestHouse";
import { databaseMenuOptions } from "../data/database";
import { hasAccess } from "../functions";
import { prodApi } from "../data/api";

const dataUrl = prodApi.data;
const guestroomUrl = `${dataUrl}/guestrooms`;

const DatabaseGuestHouse = ({ maxWidth }) => {
  const { loggedIn, isLoggedIn } = useContext(AuthContext);
  return (
    <>
      {loggedIn &&
        hasAccess(isLoggedIn.accessLevel, ["data", "omni", "admin"]) && (
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                minHeight: "110dvh",
                width: "90%",
                maxWidth: maxWidth,
                zIndex: 0,
                m: "auto",
                p: "auto",
              }}
            >
              <Box
                sx={{
                  mt: 9,
                  fontSize: "2rem",
                  fontWeight: "200",
                }}
              >
                Data Management
              </Box>
              <Box
                sx={{
                  mb: 1.5,
                  fontSize: "1.25rem",
                  fontWeight: "200",
                }}
              >
                Guest House
              </Box>
              <SubMenu menuOptions={databaseMenuOptions} />

              <Box sx={{ mt: "2rem" }}>
                <ManageGuestHouse
                  header="Manage Guest House Rooms"
                  userId={isLoggedIn.uniqueId}
                  dataUrl={guestroomUrl}
                />
              </Box>

              <Box sx={{ mt: "2rem" }}>
                <AddGuestHouse
                  header="Add New Guest House Room"
                  userId={isLoggedIn.uniqueId}
                  dataUrl={guestroomUrl}
                />
              </Box>

              <Box sx={{ height: "10dvh" }} />
            </Box>
          </Box>
        )}
    </>
  );
};

export default DatabaseGuestHouse;
